import { Forge } from "../types";
import { modulesMockData } from "@/features/modules";

export const forgesMockData: Forge[] = [
    {
        id: "1",
        creator: {
            id: "1",
            name: "InstaDeep",
            type: "3rd Party",
            avatar: "https://via.placeholder.com/150",
        },
        progress: 50,
        createdAt: "2025-05-07",
        updatedAt: "2025-05-07",
        moduleInUse: modulesMockData[0]!,
    },
    {
        id: "2",
        creator: {
            id: "2",
            name: "Andy Wang",
            type: "You",
            avatar: "https://via.placeholder.com/150",
        },
        progress: 50,
        createdAt: "2025-05-07",
        updatedAt: "2025-05-07",
        moduleInUse: modulesMockData[1]!,
    }
];